import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';

import { useApp } from '@/presentation/hooks/use-app.js';

interface Props {
    open: boolean;
    onClose: () => void;
    onConfirm: (newType: 'BUG' | 'AJUSTE_MINOR', notes: string) => Promise<unknown>;
}

export function ReclassifySolicitationDialog({ open, onClose, onConfirm }: Props) {
    const { translate } = useApp();
    const [reclassifyNewType, setReclassifyNewType] = useState<'BUG' | 'AJUSTE_MINOR' | ''>('');
    const [reclassifyNotes, setReclassifyNotes] = useState('');
    const [reclassifyingSolicitation, setReclassifyingSolicitation] = useState(false);

    useEffect(() => {
        if (open) {
            setReclassifyNewType('');
            setReclassifyNotes('');
        }
    }, [open]);

    const handleConfirmReclassifySolicitation = async () => {
        if (!reclassifyNewType) {
            return;
        }
        setReclassifyingSolicitation(true);
        await onConfirm(reclassifyNewType, reclassifyNotes);
        setReclassifyingSolicitation(false);
        onClose();
        setReclassifyNewType('');
        setReclassifyNotes('');
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>{translate('solicitations.reclassifyRequest')}</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{ mt: 1 }}>
                    <TextField
                        select
                        label={translate('solicitations.newType')}
                        value={reclassifyNewType}
                        onChange={(e) => setReclassifyNewType(e.target.value as 'BUG' | 'AJUSTE_MINOR')}
                        size="small"
                        fullWidth
                    >
                        <MenuItem value="BUG">{translate('requestTypeLabels.BUG')}</MenuItem>
                        <MenuItem value="AJUSTE_MINOR">{translate('requestTypeLabels.AJUSTE_MINOR')}</MenuItem>
                    </TextField>
                    <TextField
                        label={translate('solicitations.ltResponseLabel')}
                        placeholder={translate('solicitations.evaluationNotesPlaceholder')}
                        value={reclassifyNotes}
                        onChange={(e) => setReclassifyNotes(e.target.value)}
                        size="small"
                        multiline
                        rows={2}
                        fullWidth
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={reclassifyingSolicitation}>
                    {translate('common.cancel')}
                </Button>
                <Button
                    onClick={() => handleConfirmReclassifySolicitation()}
                    variant="contained"
                    sx={{ color: 'white' }}
                    disabled={reclassifyingSolicitation || !reclassifyNewType}
                >
                    {reclassifyingSolicitation ? translate('common.loading') : translate('solicitations.reclassify')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
